import { useMemo } from 'react';
import { useProjectTags } from '@/hooks/use-tasks';
import { SearchableSelect } from '@/components/ui/searchable-select';

export function TagPicker({
  boardId,
  value,
  onChange,
  ariaInvalid,
  ariaLabel = 'Label',
}: {
  boardId: string;
  value: string;
  onChange: (id: string) => void;
  ariaInvalid?: boolean;
  ariaLabel?: string;
}) {
  const { data: tags = [] } = useProjectTags(boardId);
  const options = useMemo(() => tags.map((t) => ({ id: t.id, name: t.name })), [tags]);
  return (
    <SearchableSelect
      value={value}
      onChange={onChange}
      options={options}
      placeholder="Pick a label…"
      allowNone={false}
      ariaInvalid={ariaInvalid}
      ariaLabel={ariaLabel}
    />
  );
}

export function TagChip({ boardId, value }: { boardId: string; value: string | undefined }) {
  const { data: tags = [] } = useProjectTags(boardId);
  const t = tags.find((x) => x.id === value);
  return (
    <span
      className="inline-flex items-center rounded px-1.5 py-0.5 text-xs"
      style={{ background: `${t?.color ?? '#888'}22`, color: t?.color ?? 'inherit' }}
    >
      {t?.name ?? value ?? '—'}
    </span>
  );
}
